module.exports = __webpack_public_path__ + "static/media/modelo-carga-censo.230379c1.xlsx";